interface MetzLogoProps {
  compact?: boolean;
}

/**
 * Code-native rendition of the supplied METZ wordmark. Keeping the mark as
 * SVG makes it sharp at both navigation widths while preserving the source
 * logo's deep-blue-to-cyan progression.
 */
export function MetzLogo({ compact = false }: MetzLogoProps) {
  return (
    <span className={`metz-logo${compact ? " metz-logo--compact" : ""}`}>
      <svg
        aria-label="METZ"
        className="metz-logo__art"
        role="img"
        viewBox="0 0 184 34"
      >
        <title>METZ</title>
        <defs>
          <linearGradient id="metz-wordmark-gradient" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor="#00517c" />
            <stop offset="0.48" stopColor="#0078a8" />
            <stop offset="1" stopColor="#00abe0" />
          </linearGradient>
        </defs>
        <g fill="url(#metz-wordmark-gradient)">
          <path d="M2 31V3h8l16 18.5L42 3h8v28h-8V14L26 32 10 14v17H2Z" />
          <path d="M60 3h35v7H68v4h24v7H68v3h27v7H60V3Z" />
          <path d="M103 3h38v7h-14.5v21h-9V10H103V3Z" />
          <path d="M149 3h33v7l-22.5 14H182v7h-36v-7l23-14H149V3Z" />
        </g>
      </svg>
    </span>
  );
}
